import React  from 'react';
import { useAuth } from '../../hooks/useAuth';
import LayoutHeader from './LayoutHeader';

type LayoutProps = {
  children: JSX.Element | JSX.Element[];
}

const Layout = ({ children }: LayoutProps): JSX.Element => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <>{ children }</>;
  }

  return (
    <>
      <LayoutHeader />
      { children }
    </>
  );
};

export default Layout;
